import { ProductOption } from '../../products/res/ProductOption';

export class Reservation {
  id: number;
  reservationNo: string;
  productOptions: ProductOption[];
  reservationStatus: ReservationStatus;
  reservedAt: Date;
  createdAt?: Date;
  partnerEmployee?: {
    id: number;
    partnerEmployeeName: string;
    partnerEmployeeProfileImageUrl?: string;
  };
  consultingEmployee?: {
    id: number;
    partnerEmployeeName: string;
    partnerEmployeeProfileImageUrl?: string;
  };
  treatmentCategoryName?: string;
  treatmentSubCategoryName?: string;
  needConsultation: boolean;
}

export enum ReservationChannel {
  KAKAO_MESSENGER = 'KAKAO_MESSENGER',
  LINE_MESSENGER = 'LINE_MESSENGER',
  WECHAT_MESSENGER = 'WECHAT_MESSENGER',
  WATCH_APP_MESSENGER = 'WATCH_APP_MESSENGER',
  NAVER_MESSENGER = 'NAVER_MESSENGER',
  CHANNEL_TALK_MESSENGER = 'CHANNEL_TALK_MESSENGER',
  NAVER = 'NAVER',
  MIMO = 'MIMO',
}

export enum ReservationStatus {
  Complete = 'COMPLETE',
  Receive = 'RECEIVE',
  Cancel = 'CANCEL',
}
